/* tslint:disable */
/* eslint-disable */
/**
 * Salv AML Platform internal API
 * Salv AML Platform internal API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface InternalApiRerunScenariosForTransactionsByTimestampRangeRequest
 */
export interface InternalApiRerunScenariosForTransactionsByTimestampRangeRequest {
    /**
     * 
     * @type {Array<string>}
     * @memberof InternalApiRerunScenariosForTransactionsByTimestampRangeRequest
     */
    scenarioHandles: Array<string>;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiRerunScenariosForTransactionsByTimestampRangeRequest
     */
    timeFrom: Date;
    /**
     * 
     * @type {Date}
     * @memberof InternalApiRerunScenariosForTransactionsByTimestampRangeRequest
     */
    timeTo: Date;
}

/**
 * Check if a given object implements the InternalApiRerunScenariosForTransactionsByTimestampRangeRequest interface.
 */
export function instanceOfInternalApiRerunScenariosForTransactionsByTimestampRangeRequest(value: object): value is InternalApiRerunScenariosForTransactionsByTimestampRangeRequest {
    if (!('scenarioHandles' in value) || value['scenarioHandles'] === undefined) return false;
    if (!('timeFrom' in value) || value['timeFrom'] === undefined) return false;
    if (!('timeTo' in value) || value['timeTo'] === undefined) return false;
    return true;
}

export function InternalApiRerunScenariosForTransactionsByTimestampRangeRequestFromJSON(json: any): InternalApiRerunScenariosForTransactionsByTimestampRangeRequest {
    return InternalApiRerunScenariosForTransactionsByTimestampRangeRequestFromJSONTyped(json, false);
}

export function InternalApiRerunScenariosForTransactionsByTimestampRangeRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): InternalApiRerunScenariosForTransactionsByTimestampRangeRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'scenarioHandles': json['scenarioHandles'],
        'timeFrom': (new Date(json['timeFrom'])),
        'timeTo': (new Date(json['timeTo'])),
    };
}

export function InternalApiRerunScenariosForTransactionsByTimestampRangeRequestToJSON(json: any): InternalApiRerunScenariosForTransactionsByTimestampRangeRequest {
    return InternalApiRerunScenariosForTransactionsByTimestampRangeRequestToJSONTyped(json, false);
}

export function InternalApiRerunScenariosForTransactionsByTimestampRangeRequestToJSONTyped(value?: InternalApiRerunScenariosForTransactionsByTimestampRangeRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'scenarioHandles': value['scenarioHandles'],
        'timeFrom': value['timeFrom'].toISOString(),
        'timeTo': value['timeTo'].toISOString(),
    };
}

